import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Sessions run on httpOnly cookies set by the backend, so no token is ever stored
// in localStorage (XSS safe). withCredentials sends those cookies on every call.
export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Onbekende fout";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
